import React, { createContext, useReducer, useContext } from 'react';
import { findIndex } from 'ramda';

const RootStateContext = createContext();
const RootDispatchContext = createContext();

const initTournamentState = {
  isFormal: false,
  isProLeague: false,
  organizerUniqid: '',
  tournamentInfo: {
    auto_game_seq: false,
    description: '',
    end_at: '',
    league: { name: '', uniqid: '' },
    config: {
      leader_board_config: { IP_weight: 0, PA_weight: 0 },
      standing_point_config: { adjudged_lose: 0, draw: 1, forfeited_lose: 0, lose: 0, win: 2 },
      IP_weight: 0,
      PA_weight: 0,
      open_leader_board: false,
      open_registration: false,
      expand_media_space: false,
      paper_record_online: false,
      offline_commissioner: false,
      player_registration: {
        avatar_ratio: '',
        columns: [],
        staffs: [],
        start_at: '',
        end_at: '',
      },
      player_verified_teams: {},
    },
    locations: [],
    name: '',
    uniqid: '',
    start_at: '',
    title: '',
    type: '',
    year: 0,
  },
  games: [],
  gameGroups: [],
  teams: [],
  locations: [],
};

const tournamentReducer = (state, action) => {
  const { type, payload } = action;
  switch (type) {
    case 'SET_ORGANIZER_UNIQID': {
      return {
        ...state,
        organizerUniqid: payload.uniqid,
        isFormal: payload.isFormal,
        isProLeague: payload.isFormal && (payload.uniqid.startsWith('CPBL') || payload.uniqid.startsWith('AWB')),
      };
    }
    case 'SET_TOURNAMENT_INFO': {
      return {
        ...state,
        tournamentInfo: payload,
      };
    }
    case 'SET_GAMES': {
      return {
        ...state,
        games: payload,
      };
    }
    case 'SET_GAME_GROUPS': {
      return {
        ...state,
        gameGroups: payload,
      };
    }
    case 'SET_TEAMS': {
      return {
        ...state,
        teams: payload,
      };
    }
    case 'SET_LOCATIONS': {
      return {
        ...state,
        locations: payload,
      };
    }
    case 'UPDATE_GAME': {
      const gameIndex = findIndex((g) => g.uniqid === payload.uniqid, state.games);
      if (gameIndex < 0) {
        return { ...state };
      }

      const newGames = [...state.games];
      newGames[gameIndex] = payload;
      return { ...state, games: newGames };
    }
    default:
      throw new Error('Invalid action type');
  }
};

const TournamentProvider = ({ children }) => {
  const [state, dispatch] = useReducer(tournamentReducer, initTournamentState);

  return (
    <RootStateContext.Provider value={state}>
      <RootDispatchContext.Provider value={dispatch}>{children}</RootDispatchContext.Provider>
    </RootStateContext.Provider>
  );
};

const useTournamentState = () => {
  const context = useContext(RootStateContext);

  if (context === undefined) {
    throw new Error('useTournamentState must be used within a TournamentProvider');
  }
  return context;
};

const useTournamentDispatch = () => {
  const context = useContext(RootDispatchContext);

  if (context === undefined) {
    throw new Error('useTournamentDispatch must be used within a TournamentProvider');
  }
  return context;
};

export { TournamentProvider, useTournamentState, useTournamentDispatch };
